module.exports = __webpack_public_path__ + "08d8dfaa37ff7478644b0fde3aea48fe.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/skillset-banners/banner-desert.png
// module id = 3629
// module chunks = 0